import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import authReduce from './store/reduce/auth';
import answeredConversationReduce from './store/reduce/answered-conversations';
import unAnsweredConversationReduce from './store/reduce/unanswered-conversations';
import conversationInAttendanceReduce from './store/reduce/conversation-in-attendance';
import createObject from './store/reduce/reducerChatConfig';
import telephonyServicePanelReducer from './store/reduce/telephonyServicePanelReducer';
import navigationSoftphone from './store/reduce/nextNavigation';
import sidebarReducer from './store/reduce/sidebarReducer';
import systemConfiguration from './store/reduce/systemConfiguration';
import activeChatInternal from './store/reduce/reducerInternalChat';
import orderListUser from './store/reduce/orderInternalChat';
import sideDrawerReducer from './store/reduce/sideDrawerReducer';
import contactEventsReducer from './store/reduce/contactEventsReducer';
import updateChatMetrics from './store/reduce/update-chat-metrics';
import { monitoringChatReducer } from 'store/reduce/monitoringChat';
import queuesReducer from 'store/reduce/queuesReducer';
import broadcastListReducer from 'store/reduce/broadcastListReducer';
import { CHATS_BY_AGENT_LOGIN_SLICE_NAME } from 'store/reduce/chats-by-agent-login';
import chatsByAgentLoginReducer from 'store/reduce/chats-by-agent-login';
import agentProfilePicturesReducer from 'store/reduce/agent-profile-picture';
import { AGENT_PROFILE_PICTURE_SLICE_NAME } from 'store/reduce/agent-profile-picture';
import gasOrderReducer from 'store/reduce/gasOrderReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth: authReduce,
  answeredConversation: answeredConversationReduce,
  unAnsweredConversation: unAnsweredConversationReduce,
  conversationInAttendance: conversationInAttendanceReduce,
  telephonyServicePanel: telephonyServicePanelReducer,
  createObject,
  navigationSoftphone,
  sidebarReducer,
  systemConfiguration,
  activeChatInternal,
  orderListUser,
  sideDrawer: sideDrawerReducer,
  contactEvents: contactEventsReducer,
  updateChatMetrics,
  monitoringChat: monitoringChatReducer,
  queues: queuesReducer,
  broadcastList: broadcastListReducer,
  gasOrderReducer,
  [CHATS_BY_AGENT_LOGIN_SLICE_NAME]: chatsByAgentLoginReducer,
  [AGENT_PROFILE_PICTURE_SLICE_NAME]: agentProfilePicturesReducer
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
